import React from 'react'
import Svg, { G, Ellipse, Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconSearch = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconSearch.dimensions.width} ${IconSearch.dimensions.height}`}
      {...otherProps}
    >
      <G fill="none" fillRule="evenodd">
        <G transform="translate(.844)">
          <Ellipse cx={10.119} cy={10.047} rx={10.119} ry={10.047} />
          <Path
            d="M10.119 0c5.587 0 10.119 4.496 10.119 10.047 0 5.55-4.532 10.047-10.119 10.047S0 15.598 0 10.047C0 4.497 4.532 0 10.119 0zm0 2C5.633 2 2 5.605 2 10.047s3.633 8.047 8.119 8.047 8.119-3.605 8.119-8.047S14.605 2 10.119 2z"
            fill={color || Color.premiumBlack}
            fillRule="nonzero"
          />
        </G>
        <Path
          d="M4.576 16.787l-3.914 4.44a1 1 0 101.5 1.323l3.914-4.44a1 1 0 10-1.5-1.323z"
          fill={color || Color.premiumBlack}
          fillRule="nonzero"
        />
      </G>
    </Svg>
  )
}

IconSearch.dimensions = {
  width: 22,
  height: 23,
}

export default IconSearch
